import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { uploadSingleMedia, uploadMultipleMedia } from "../services/media.service";
import {
  MediaUploadRequest,
  MediaUploadResponse,
  BatchMediaUploadRequest,
  MediaUploadError,
} from "../types/media.types";

export const useSingleMediaUpload = (): UseMutationResult<
  MediaUploadResponse,
  MediaUploadError,
  MediaUploadRequest
> => {
  return useMutation({
    mutationFn: uploadSingleMedia,
    onError: (error) => {
      console.error("Media upload failed:", error);
    },
  });
};

export const useMultipleMediaUpload = (): UseMutationResult<
  MediaUploadResponse[],
  MediaUploadError,
  BatchMediaUploadRequest
> => {
  return useMutation({
    mutationFn: uploadMultipleMedia,
    onError: (error) => {
      console.error("Batch media upload failed:", error);
    },
  });
};
